import type { FC, PropsWithChildren } from "react";
import * as s from "./Header.module.scss";

type HeaderProps = PropsWithChildren<{
	headline: string;
	label?: string;
}>;

const Header: FC<HeaderProps> = ({ children, headline, label }) => {
	return (
		<header className={s.header}>
			<div className={s.labels}>
				{children}
				{label && <span className={s.label}>{label}</span>}
			</div>
			<h2 className={s.headline}>{headline}</h2>
		</header>
	);
};

export default Header;
